import React from "react";
import { NavLink } from "react-router-dom";
import { CATEGORIES } from "../api/api";
import "../styles/Sidebar.css";
import { IoHome } from "react-icons/io5";

export default function Sidebar({ isOpen, onClose }) {
  return (
    <>
      {isOpen && <div className="sidebar-backdrop" onClick={onClose} />}

      <aside className={"sidebar" + (isOpen ? " sidebar-open" : "")}>
        <div className="sidebar-brand">
          <span className="sidebar-brand-mark"><img src="/assets/icon.png" alt="TT" /></span>
          <span className="sidebar-brand-text">Today Talks</span>
          <button
            className="sidebar-close"
            onClick={onClose}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <NavLink
          to="/"
          end
          onClick={onClose}
          className={({ isActive }) =>
            "sidebar-link sidebar-link-home" + (isActive ? " sidebar-link-active" : "")
          }
        >
          <span className="sidebar-link-icon"><IoHome /></span>
          Overview
        </NavLink>

        <nav className="sidebar-nav">
          <p className="sidebar-nav-heading">Categories</p>
          {CATEGORIES.map((cat) => (
            <NavLink
              key={cat.key}
              to={`/category/${cat.key}`}
              onClick={onClose}
              className={({ isActive }) =>
                "sidebar-link" + (isActive ? " sidebar-link-active" : "")
              }
            >
              <span className="sidebar-link-icon">{cat.icon}</span>
              {cat.label}
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
}
